import { useState } from 'react'
import type { FunctionComponent } from 'react'
import styled from 'styled-components'
import { useIdleTimer } from 'react-idle-timer'
import { logout } from '../../utils/auth/auth'
import Paragraph from '../Paragraph/Paragraph'
import Modal from '../Modal/ModalElements/Modal'

const StyledModal = styled(Modal)`
  max-width: 95%;
  @media screen and (min-width: 48rem) {
    max-width: 620px;
  }
`

const ModalBody = styled.div`
  padding-top: 1rem;
`

interface IdleTimeLogoutProps {
  // In milliseconds, how long a user can be inactive for
  timeout: number
}

const IdleTimeLogout: FunctionComponent<IdleTimeLogoutProps> = ({ timeout }) => {
  const [modalOpen, setModalOpen] = useState(false)

  const handleIdle = () => {
    setModalOpen(true)
    document.body.style.overflow = 'hidden'

    setTimeout(() => {
      logout()
    }, 5000)
  }

  useIdleTimer({
    timeout,
    onIdle: handleIdle,
    crossTab: true,
    debounce: 500,
  })

  return (
    <StyledModal open={modalOpen} title="Uw sessie is verlopen">
      <ModalBody>
        <Paragraph>
          Na 15 minuten inactiviteit loggen wij u uit, log opnieuw in om uw sessie te hervatten.
        </Paragraph>
      </ModalBody>
    </StyledModal>
  )
}

export default IdleTimeLogout
